import { createStore } from 'vuex'
import axios from 'axios';

import shuffle from '../utils/shuffle';

export default createStore({
	state: {
		data: [],
		sceptisch: 0,
		guests: new Set(),
		totalGuests: 4,
		gastenSceptisch: 0,
		gastenNietSceptisch: 0,
		naam: ''
	},
	mutations: {
		SAVE_DATA (state, data) {
			state.data = data;
			state.options = shuffle(data.personen);
		}, 

		SAVE_STANDPUNT (state, standpunt) {
			state.sceptisch = standpunt;
		},

		ADD_COUNT(state, guest) {
			guest.sceptisch ? state.gastenSceptisch++ : state.gastenNietSceptisch++;

		},

		SUBTRACT_COUNT(state, guest) {
			guest.sceptisch ? state.gastenSceptisch-- : state.gastenNietSceptisch--;
		},

		UPDATE_GUESTS (state, guest) {

			if(state.guests.has(guest)){
				guest.uitgenodigd = false;
				state.guests.delete(guest);
				this.commit("SUBTRACT_COUNT", guest);
			} else {

				// niet meer dan 4 gasten
				if(state.guests.size >= state.totalGuests) return;

				guest.uitgenodigd = true;
				state.guests.add(guest);
				this.commit("ADD_COUNT", guest);
			}
		},

		EMPTY_GUESTS(state) {
			state.guests.forEach((gast) => {
				state.guests.delete(gast);
			})
		},

		UPDATE_NAAM(state, naam) {
			state.naam = naam;
		}
	},
	getters: {
		data: state => state.data,

		options: state => state.options,

		naam: state => state.naam,

		guests: state => state.guests,

		totalGuests: state => state.guests.size,

		guestIds: (state) => () => {
			let arr = [];
			state.guests.forEach( d => arr.push(d.id))

			return arr;
		},

		count: state => state.sceptisch ? state.gastenNietSceptisch : state.gastenSceptisch,

		standpunt: state => state.sceptisch,


		getGuestById: (state) => (id) => {
			console.log(state.options)
			let item = state.options.find(d => d.id === id);
			return item;
		},


		isInvited: (state) => (guest) => {
			return state.guests.has(guest);
		},

		getScenario: (state) => () => {
			let punten = state.sceptisch ? state.gastenNietSceptisch : state.gastenSceptisch;
			let scenario = state.data.scenarios.opties.find(d => d.punten === punten);

			return scenario;
		}		

	},
	actions: {
		loadData ({ commit, state }) {
			return new Promise((resolve, reject) => { 
				axios
					.get(process.env.VUE_APP_API)
					.then(result => {
						commit("SAVE_DATA", result.data);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})
		},    

		updateStandpunt({commit, state}, payload) {
			commit("SAVE_STANDPUNT", payload.state);
		},

		updateGuests({commit, state}, data) {
			commit("UPDATE_GUESTS", data);
		},

		emptyGuests({commit, state}) {
			state.guests.forEach((gast) => {
				commit("UPDATE_GUESTS", gast);
			})
		},

		getmeAnInterestingTable({commit, state}) {
			state.options.forEach((gast) => {
				if(state.sceptisch !== gast.sceptisch) {
					commit("UPDATE_GUESTS", gast);
				}
			})
		},

		updateNaam({commit, state}, naam) {
			commit("UPDATE_NAAM", naam);
		}

	},
	modules: {

	}
})
